import { memo, useContext } from 'react';
import Editor from 'components/CKEditor/Editor';
import { EditorPreviewContext } from 'context/EditorPreviewContext';
import { AppTextField } from 'components';

function ShortAnswer({ handleSave, data }) {
  const { PreviewBtn } = useContext(EditorPreviewContext);

  return (
    <div className="tab__content-actBody">
      <div className="px-5">
        <div className="row mt-4">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <div className="lessonWrap lessonWrap--border topalign ___short__answer__sub">
              <div className="w-100 p-3">
                <label htmlFor="questionToFill">Question</label>
                {data?.title && <PreviewBtn block={{ value: data.title }} />}
                <Editor
                  data={{
                    value: data?.title || '',
                    onChange: (editorData) => {
                      handleSave({ title: editorData });
                    },
                  }}
                  config={{
                    placeholder: 'Enter the question here',
                  }}
                />
              </div>
              <div className="w-100 p-3">
                <label htmlFor="questionToFill">Answer</label>
                {data?.answer && <PreviewBtn block={{ value: data.answer }} />}
                <Editor
                  data={{
                    value: data?.answer || '',
                    onChange: (editorData) => {
                      handleSave({ answer: editorData });
                    },
                  }}
                  config={{
                    placeholder: 'Enter the short answer here',
                  }}
                />
              </div>

              <div className="w-100 p-3 mt-4">
                <label htmlFor="">Hint</label>
                {data?.hint && <PreviewBtn block={{ value: data?.hint || '' }} />}
                <Editor
                  data={{
                    value: data?.hint || '',
                    onChange: (data) => handleSave({ hint: data }),
                  }}
                />
              </div>

              <div className="w-100 p-3">
                <label htmlFor="">Explanation</label>
                {data?.explanation && <PreviewBtn block={{ value: data?.explanation || '' }} />}
                <Editor
                  data={{
                    value: data?.explanation || '',
                    onChange: (data) => handleSave({ explanation: data }),
                  }}
                />
              </div>
              <div className="w-100 p-3">
                <AppTextField
                  labelProps={{ label: 'Marks' }}
                  inputProps={{
                    placeholder: 'Please provide the maximum marks allocated',
                    value: data?.marks || '',
                    onChange: (event) => handleSave({ marks: event.target.value }),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(ShortAnswer);
